// extracted by mini-css-extract-plugin
export var link = "NavLinkButton-module--link--NajAG";
export var arrow = "NavLinkButton-module--arrow--sfKKq";